import { z } from 'zod';

import { PropertyId } from '../BrandedIds';
import { zodBrandedUuid, zodDateOrString } from '../utils';
import { BaseLoanEvent } from './BaseLoanEvent';

export const AddAppraisalOrderEvent = BaseLoanEvent.extend({
  type: z.literal('addAppraisalOrder'),
  propertyId: zodBrandedUuid<PropertyId>(),
  date: zodDateOrString,
  vendorName: z.string(),
});

export type AddAppraisalOrderEvent = z.infer<typeof AddAppraisalOrderEvent>;
